module.exports = __webpack_public_path__ + "img/product-placeholder-65.7f76c26.png";